// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 17.575 16.763\"> <path d=M-3550.916,4375.445l2.561,5.189,5.727.832-4.144,4.04.978,5.7-5.122-2.692-5.122,2.692.979-5.7-4.144-4.04,5.727-.832Z transform=\"translate(3559.704 -4374.945)\" stroke-linecap=round stroke-linejoin=round stroke-width=1 /> </svg>";
// Exports
module.exports = code;